export enum WarehouseTypes {
    Servicing = "Servicing",
    DisplayOnly = "DisplayOnly",
}
